// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DA\\+fDwoTNQDn598sfdcmGg\\=\\=:hover {\n    cursor: pointer;\n    background-color: rgba(0, 0, 0, 0.04)\n}\n\n.QNZjJ2SgIfk1UufsqHPmhw\\=\\= {\n    width: 100%;\n    overflow-wrap: anywhere;\n}", "",{"version":3,"sources":["webpack://./src/shared/styles/AlertWarning.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B","sourcesContent":[".typographyLink:hover {\n    cursor: pointer;\n    background-color: rgba(0, 0, 0, 0.04)\n}\n\n.list {\n    width: 100%;\n    overflow-wrap: anywhere;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"typographyLink": "DA+fDwoTNQDn598sfdcmGg==",
	"list": "QNZjJ2SgIfk1UufsqHPmhw=="
};
export default ___CSS_LOADER_EXPORT___;
